import {baseRequestService} from "../../base.ts";
import {UserContact} from "../../../types/domain.ts";

export const usersUserIdContactsGet = (userId: number) =>
    baseRequestService<UserContact[]>({
        url: `/users/${userId}/contacts`,
        method: 'GET'
    })